import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MdSearch } from 'react-icons/md';
import { heroData } from '../utils/data';
import GameContainer from './GameContainer';
import { useLang } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';

const GamesContainer = () => {
  const { lang } = useLang();
  const t = translations[lang].games;

  const [filter, setFilter] = useState('sports');
  const [search, setSearch] = useState('');

  const filtered = heroData.filter(g =>
    g.genre.toLowerCase() === filter &&
    g.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full min-h-screen bg-gray-950" id="games">

      {/* ── Banner ── */}
      <div className="relative w-full bg-gray-950 pt-10 pb-16 px-6 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px)', backgroundSize: '50px 50px' }} />
        <div className="absolute right-0 top-0 w-[500px] h-[400px] bg-headingColor/8 rounded-full blur-[100px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-950 to-transparent pointer-events-none" />
        <div className="relative max-w-7xl mx-auto">
          <p className="text-headingColor text-xs font-bold tracking-widest uppercase mb-3">{t.eyebrow}</p>
          <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight mb-4">{t.title}</h1>
          <p className="text-gray-500 text-sm max-w-sm">{t.subtitle}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-20">
        {/* ── Filters ── */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-10">
          <div className="relative flex-shrink-0">
            <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600 text-lg" />
            <input
              type="text" value={search} onChange={e => setSearch(e.target.value)}
              placeholder={t.searchPlaceholder}
              className="bg-gray-900 border border-white/8 text-white placeholder-gray-600 rounded-xl pl-9 pr-4 py-2.5 text-sm outline-none focus:border-headingColor/40 transition-colors w-56"
            />
          </div>

          <div className="flex flex-wrap gap-2">
            {t.categories.map(cat => (
              <motion.button
                whileTap={{ scale: 0.95 }} key={cat.id}
                onClick={() => setFilter(cat.urlParamName)}
                className={`px-4 py-2 rounded-lg text-xs font-bold tracking-widest uppercase transition-all duration-200 ${
                  filter === cat.urlParamName
                    ? 'bg-headingColor text-white shadow-lg shadow-red-950/30'
                    : 'bg-gray-900 border border-white/8 text-gray-500 hover:text-white hover:border-white/20'
                }`}
              >
                {cat.name}
              </motion.button>
            ))}
          </div>

          <span className="text-gray-600 text-xs ml-auto">{t.gameCount(filtered.length)}</span>
        </div>

        <GameContainer data={filtered} />
      </div>
    </div>
  );
};

export default GamesContainer;
